function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdnexioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 23 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-14,-344.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard3",
    transform: "matrix(1,0,0,1,766,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -766,
    y: 334,
    width: 632,
    height: 398.728,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-752,342.797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.22,7.185L13.898,2.38C13.478,2.138 12.96,2.138 12.538,2.38L7.79,5.121C7.259,5.428 7.259,6.194 7.79,6.499L15.594,11.004C16.026,11.253 16.29,11.714 16.29,12.21L16.29,22.57L6.618,16.991L12.095,13.83C12.605,13.535 12.605,12.798 12.095,12.503L7.272,9.719C6.87,9.486 6.372,9.486 5.969,9.719L0.645,12.79C0.246,13.021 0,13.447 0,13.908L0,20.174C0,20.567 0.209,20.93 0.549,21.126L15.604,29.817C16.028,30.061 16.55,30.061 16.972,29.817L22.216,26.79C22.646,26.542 22.91,26.085 22.91,25.589L22.91,8.38C22.91,7.886 22.646,7.431 22.218,7.183L22.22,7.185Z",
    style: {
      fill: "rgb(243,191,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-752,342.797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.29,22.568L22.722,26.288C22.843,26.079 22.91,25.84 22.91,25.59L22.91,8.38C22.91,8.134 22.843,7.896 22.724,7.689L16.102,11.512C16.223,11.722 16.288,11.96 16.288,12.208L16.288,22.568L16.29,22.568Z",
    style: {
      fill: "rgb(208,154,1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-752,342.797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.17,13.267C0.061,13.461 0,13.679 0,13.908L0,20.174C0,20.372 0.053,20.559 0.147,20.723L6.616,16.987L0.17,13.267Z",
    style: {
      fill: "rgb(208,154,1)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdnexioLogo);
export default __webpack_public_path__ + "static/media/adnexio-logo.b27279ada9506f19d08020bf4c782946.svg";
export { ForwardRef as ReactComponent };